import { cn } from "@utils/tw"

export const themes = {
  slateLight: {
    bg: "bg-slate400",
    text: "text-slate950",
    button: "primary",
  },
  slateLighter: {
    bg: "bg-slate300",
    text: "text-slate950",
    button: "mediumDark",
  },
  slateMedium: {
    bg: "bg-slate600",
    text: "text-slate50",
    button: "mediumDark",
  },
  slateMediumDark: {
    bg: "bg-slate700",
    text: "text-slate50",
    button: "dark",
  },
  slateDark: {
    bg: "bg-slate950",
    text: "text-slate50",
    button: "primary",
  },
  orange: {
    bg: "bg-orange",
    text: "text-slate950",
    button: "dark",
  },
}

export const Themed = ({
  theme = "slateLight",
  children,
  className,
}: {
  theme?: keyof typeof themes
  children: React.ReactNode
  className?: string
}) => {
  const themeObj = themes[theme as keyof typeof themes] ? themes[theme as keyof typeof themes] : themes.slateLight
  const bg = themeObj.bg
  const text = themeObj.text

  return <div className={cn(bg, text, className)}>{children}</div>
}
